/**
 * Парсинг ссылок VK / VK Video для встраивания на сайте.
 * Поддерживает: vkvideo.ru/video-OWNER_VIDEO, vk.com/video-OWNER_VIDEO
 */
export function parseVkVideoUrl(url) {
  if (!url || typeof url !== 'string') return null
  const match = url.match(/video(-?\d+)_(\d+)/)
  if (!match) return null
  return { oid: match[1], id: match[2] }
}

export function getVkVideoEmbedUrl(url) {
  const parsed = parseVkVideoUrl(url)
  if (!parsed) return null
  return `https://vk.com/video_ext.php?oid=${parsed.oid}&id=${parsed.id}&hd=2`
}
